import React, { useState } from 'react';

export default function BulkSender() {
  const [file, setFile] = useState(null);
  const [templateName, setTemplateName] = useState('');
  const [languageCode, setLanguageCode] = useState('en');
  const [status, setStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file || !templateName) {
      setStatus('❌ Please select an Excel file and enter a template name.');
      return;
    }

    setIsLoading(true);
    setStatus('Uploading and starting broadcast...');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('templateName', templateName);
    formData.append('languageCode', languageCode);

    try {
      const response = await fetch('http://localhost:3000/api/broadcast', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (response.ok) {
        setStatus(`✅ Success: ${data.message} (${data.total_records} records found)`);
      } else {
        setStatus(`❌ Error: ${data.error}`);
      }
    } catch (error) {
      setStatus(`❌ Network Error: Make sure your Express server is running.`);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow-sm border-0">
            {/* Header */}
            <div className="card-header bg-success text-white py-3">
              <h4 className="card-title mb-0">WhatsApp Bulk Sender</h4>
              <small>Election Management Software Module</small>
            </div>

            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                
                {/* Template Name Input */}
                <div className="mb-4">
                  <label className="form-label fw-bold">Template Name</label>
                  <input 
                    type="text" 
                    className="form-control"
                    value={templateName} 
                    onChange={(e) => setTemplateName(e.target.value)} 
                    placeholder="e.g., election_campaign_2026"
                  />
                  <div className="form-text">Must match the name approved in Meta Dashboard.</div>
                </div>

                {/* Language Select */}
                <div className="mb-4">
                  <label className="form-label fw-bold">Language Code</label>
                  <select 
                    className="form-select"
                    value={languageCode} 
                    onChange={(e) => setLanguageCode(e.target.value)}
                  >
                    <option value="en">English (en)</option>
                    <option value="hi">Hindi (hi)</option>
                    <option value="gu">Gujarati (gu)</option>
                  </select>
                </div>

                {/* File Upload */}
                <div className="mb-4">
                  <label className="form-label fw-bold">Voter List (Excel File)</label>
                  <input 
                    type="file" 
                    className="form-control"
                    accept=".xlsx, .xls" 
                    onChange={handleFileChange}
                  />
                  <div className="form-text">Upload .xlsx file with 'Phone Number' and variables.</div>
                </div>

                {/* Submit Button */}
                <div className="d-grid">
                  <button 
                    type="submit" 
                    className="btn btn-success btn-lg fw-bold py-3"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending Broadcast...
                      </>
                    ) : (
                      '🚀 Start Bulk Send'
                    )}
                  </button>
                </div>
              </form>

              {/* Status Display */}
              {status && (
                <div className={`alert mt-4 ${status.includes('✅') ? 'alert-success' : 'alert-danger'} border-0 shadow-sm`}>
                  {status}
                </div>
              )}
            </div>
          </div>
          
          <p className="text-center text-muted mt-4 small">
            Designed for <strong>HL Group of Companies</strong> • 2026
          </p>
        </div>
      </div>
    </div>
  );
}